import * as React from 'react';
import './ReturnsCartSlide.scss';

import SlideMenu from 'src/components/common/SlideMenu/SlideMenu';
import ReturnsOptions from './components/ReturnsOptions';
import ReturnsTable from './components/ReturnsTable';
import ShippingOptions from './components/ShippingOptions';
import DistributionOptions from './components/DistributionOptions';
import BoxInfo from './components/BoxInfo';
import DropOffStore from './components/DropOffStore';
import SelfShipping from './components/SelfShipping';
import BoxConfirm from './components/BoxConfirm';
import SaveForLaterConfirm from './components/SaveForLaterConfirm';
import Button from 'src/components/common/Button';
import cartService from 'src/services/cart/CartService';
import locationServiceInstance from 'src/services/location/LocationService';
import {
  IEligibleItem,
  IReturnOptionConfig,
  IStatusFilter,
  IReturnGenerateShippingLabel,
  IReturnGenerateShippingLabelResponse,
  IReturnShippingConfig
} from 'src/services/returns/typings';
import {
  ADD_EXISTING,
  ADD_NEW,
  SAVE_FOR_LATER,
  SUBMIT_NOW
} from '../ReturnsCartModal/components/ReturnsOptions/ReturnsOptions';
import { ERmaStatus } from '../StatusTab/StatusTab';
import hasComma from 'src/utils/hasComma';
import { useRef } from 'react';

interface IReturnsCartSlideProps {
  showSlide: boolean;
  closeSlide: () => void;

  partsToReturn: IEligibleItem[];
  rmaList: string[];
  removePartFromReturnList: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
  onSaveForLater: (config: IReturnOptionConfig, callback?: () => void) => void;
  onSubmitNow: (
    config: IReturnShippingConfig,
    callback?: (rmaNumber: string) => void
  ) => void;
  onUpdateNow: (
    config: IReturnShippingConfig,
    callback?: (rmaNumber: string,resUpsCharges:IReturnGenerateShippingLabelResponse) => void
  ) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  getStatusItems: (body?: IStatusFilter) => void;
  typeOfItemEligible: string;
  getRMALists: (body?: IStatusFilter) => void;
  filters: {
    status: string;
    search: any;
  };
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  showSubmitAlert: (rmaNumber: string) => void;
  userData:any;
  handleShippingLabelErrorMessageForPrintPopup: (shippingErrorMessage: string) => void;
  t?: any;
}

const ReturnsCartSlide: React.FC<IReturnsCartSlideProps> = props => {
  const {
    showSlide,
    closeSlide,
    rmaList,
    partsToReturn,
    removePartFromReturnList,
    editPartFromReturnList,
    onSaveForLater,
    onSubmitNow,
    onUpdateNow,
    handleOpenBarcodeModal,
    getStatusItems,
    typeOfItemEligible,
    getRMALists,
    filters,
    clearStatusFilters,
    clearEligibleFilters,
    showSubmitAlert,
    userData,
    handleShippingLabelErrorMessageForPrintPopup,
    t
  } = props;

  const [selectedOption, setSelectedOption] = React.useState<string>(
    ADD_EXISTING
  );
  const [poNumber, setPoNumber] = React.useState('');
  const [rmaSelected, setRmaSelected] = React.useState('');

  const [shippingTabToShow,setShippingTabToShow]=React.useState(true);
  const [checkShippingOtiopn,setCheckShippingOption]=React.useState(true);
  const [shippingSelectedOption, setShippingSelectedOption] = React.useState('');
  const [distributionSelectedOption, setDistributionSelectedOption] = React.useState('');
  const [tabTitle,setTabTitle]=React.useState('Shipping Options');
  const [shppingType,setShippingType]=React.useState('');
  const [tabBackButtonText,setTabBackButtonText]=React.useState('');
  const [storeList,setStoreList]=React.useState([]);
  const [isLoader,setIsLoader]=React.useState(false);

  const [upsResponseData,setupsResponseData]=React.useState([]);
  const [warehouseCodeVal, setWarehouseCode] = React.useState('');
  const [shppingTypeVal,setShippingTypeVal]=React.useState('');
  const [trackingNumbersVal,setTrackingNumbers]=React.useState([]);

  const [confirmBox,setConfirmBox]=React.useState(false);
  const [upsTotalShippingCharge,setupsResponseTotal]=React.useState<number>(0);
  const [submitButtonEnabled,setsubmitButtonEnabled]=React.useState<number>(1);
  const [preSaveForLaterAlt, setPreSaveForLaterAlt] = React.useState<boolean>(false);
  const [totalItemPrice, setTotalAddedItemPrice] = React.useState<number>(0);
  
  const [selfShippingWarehouseCode, setSelfShippingWarehouseCode] = React.useState('');
  const [toShippingWarehouseCode, setToShippingWarehouseCode] = React.useState('');
  const [upsErrorMessage,setUpsErrorMessage]=React.useState('');
  const [shippingLabelRequest, setShippingLabelRequest]=React.useState([]);

  const ref = useRef(null);

  React.useEffect(() => {
    setRmaSelected(rmaList.length > 0 && rmaList[0]);

    if (rmaList.length > 0) {
      setSelectedOption(ADD_EXISTING);
    } else {
      setSelectedOption(ADD_NEW);
    }
  }, [rmaList]);

  React.useEffect(() => {
    /* Calculate total added item price */
    let totalAddedItemPrice=0;
    if(partsToReturn.length>0){
    partsToReturn.map((res)=>{
      let priceWithQtyCal=res.price*res.returnQuantity;
      let priceAsRestockingFee=0;
      if(res.returnFee>0){
        priceAsRestockingFee=(res.price*res.returnFee/100);
      }else{
        priceAsRestockingFee=0;
      }
      priceWithQtyCal=priceWithQtyCal-priceAsRestockingFee;
      totalAddedItemPrice=totalAddedItemPrice+priceWithQtyCal;
    });
    setTotalAddedItemPrice(totalAddedItemPrice);
  }
  }, [partsToReturn]);

  const handleSelectedRma = (value: string) => {
    setRmaSelected(value);
  };

  const handlePoNumber = (e: any) => {
    if (!hasComma(e.target.value)) {
      setPoNumber(e.target.value);
    }
  };

  const handleChangeOption = (e: any) => {
    // if (rmaList.length > 0) {
      setSelectedOption(e.target.value);
    // }
  };

  const getAddresses = async (
    postalCode: string,
    value?: boolean
  ) => {
    const newStoreList: any[] = [];

    newStoreList.push({
      code: '0',
      name: 'Select',
      addr: 'warehouse'
    });

    await locationServiceInstance
      .getLocations(postalCode, value)
      .then(addresses => {
        addresses.forEach((address: any) => {
          newStoreList.push({
            code: address.code,
            name: address.name,
            addr: address.addressLine1
          });
        });
      });

    return newStoreList;
  };

  const getStoreList=async()=>{
    let deliveryAddresses: any[] = [];
    await cartService.getCartShippingAddress().then(async r => {
      deliveryAddresses = await getAddresses(
        r.deliveryLocation.postalCode,
        false
      );
      setStoreList(deliveryAddresses);
      setIsLoader(false);
    });
    
  };

  const handleShippingChangeOption = (e: any) => {
    setShippingSelectedOption(e.target.value);
    
    /* Drop Off at Store Clicked */
    if(e.target.value==="dropOffAtStore"){
      setIsLoader(true);
      setCheckShippingOption(true);
      getStoreList();
      
    }else{
      setCheckShippingOption(false);
      setTabTitle('SHIP TO DISTRIBUTION CENTER ');
      setTabBackButtonText('Back to Shipping Option');
      setShippingType('INDISTRIBUTIONSCREEN');
    }
    
};

const handleDistributionChangeOption = (e: any) => {
  if(e.target.value==="selfShipping"){
    setIsLoader(true);
    getStoreList();
    setWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }else{
    setSelfShippingWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }
  setDistributionSelectedOption(e.target.value);
};

const handleBackButtion = () => {
  if(shppingType==="INDISTRIBUTIONSCREEN"){
    /* Back To Shiiping Option */
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setCheckShippingOption(true);
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
  }
};

  const isDisabled = (): boolean => {
    const foundIndex = partsToReturn.findIndex(
      part => part.returnQuantity <= 0
    );
    return (
      submitButtonEnabled===1 ||(rmaList.length === 0 && selectedOption === ADD_EXISTING) ||
      partsToReturn.length === 0 ||
      foundIndex !== -1
    );
  };

  const isDisabledLater = (): boolean => {
    const foundIndex = partsToReturn.findIndex(
      part => part.returnQuantity <= 0
    );
    return (
      (rmaList.length === 0 && selectedOption === ADD_EXISTING) ||
      partsToReturn.length === 0 ||
      foundIndex !== -1
    );
  };
  
  const handlePreSaveForLater=()=>{
    setPreSaveForLaterAlt(true);
    setCheckShippingOption(false);
  }

  const handleSaveForLater = () => {
    closeSlide();
    onSaveForLater(
      {
        type: selectedOption,
        rmaNumber: rmaSelected,
        poNumber,
        items: partsToReturn,
        submissionType: SAVE_FOR_LATER
      },
      () => {
        clearStatusFilters();
        clearEligibleFilters();
        getStatusItems({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
        });
        getRMALists({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
          rmaListStatus: ERmaStatus.NOT_SUBMITTED
        });
        setSelectedOption(ADD_EXISTING);
        setPoNumber('');
        setRmaSelected('');
        setShippingSelectedOption('');
        setDistributionSelectedOption('');
        setCheckShippingOption(true);
        setTabTitle('SHIPPING OPTIONS');
        setTabBackButtonText('');
        setPreSaveForLaterAlt(false);
        closeSlide();

      }
    );
  };

  const handleSubmitNow = () => {
    let selectedWarehouseCode='';
    const upsTrakingNoArr: any=[];
    if(shppingTypeVal==="DROP_OFF_STORE"){
      selectedWarehouseCode=warehouseCodeVal;
    }else if(shppingTypeVal==="SELF_SHIPPING"){
      selectedWarehouseCode=selfShippingWarehouseCode
    }
    if(distributionSelectedOption==="purchasePrepaidShipping"){
      onUpdateNow(
        {
          type: selectedOption,
          rmaNumber: rmaSelected,
          poNumber,
          items: partsToReturn,
          submissionType: SUBMIT_NOW,
          shippingType:shppingTypeVal,
          shippingLabelRequest
        },
        (rmaNumber: string,resUpsCharges: IReturnGenerateShippingLabelResponse) => {
          if (resUpsCharges.message !== null) {
            setIsLoader(false);
            setUpsErrorMessage(resUpsCharges.message);
            handleShippingLabelErrorMessageForPrintPopup(resUpsCharges.message);
            handleOpenBarcodeModal(rmaNumber, []);
          }else{
            setUpsErrorMessage('');
            // setConfirmBox(true);
            setupsResponseData(resUpsCharges.shippingLabelExtendedInfo);
            handleOpenBarcodeModal(rmaNumber, resUpsCharges.shippingLabelExtendedInfo);
            setupsResponseTotal(parseFloat(resUpsCharges.total));
          }
          clearStatusFilters();
          clearEligibleFilters();
          getStatusItems({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
          });
          getRMALists({
            itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
            rmaListStatus: ERmaStatus.NOT_SUBMITTED
          });
            closeSlide();  
            setConfirmBox(false);
            setIsLoader(false);
            setCheckShippingOption(false);
            setShippingSelectedOption('')
            setTabTitle('CONFIRMATION');
            setTabBackButtonText('');
        }
      );

    }else{

      onSubmitNow(
        {
          type: selectedOption,
          rmaNumber: rmaSelected,
          poNumber,
          items: partsToReturn,
          submissionType: SUBMIT_NOW,
          shippingType:shppingTypeVal,
          warehouseCode:'',
        },
        (rmaNumber: string) => {
          clearStatusFilters();
          clearEligibleFilters();
          getStatusItems({
            itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
          });
          getRMALists({
            itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
            rmaListStatus: ERmaStatus.NOT_SUBMITTED
          });
          setSelectedOption(ADD_EXISTING);
          setPoNumber('');
          setRmaSelected('');
          showSubmitAlert(rmaNumber);
          handleOpenBarcodeModal(rmaNumber, []);
          setShippingSelectedOption('');
          setDistributionSelectedOption('');
          setCheckShippingOption(true);
          setTabTitle('SHIPPING OPTIONS');
          setTabBackButtonText('');
          setPreSaveForLaterAlt(false);
          closeSlide();
        }
      );

    }
  };
    /* Send Shiiping Lable Request Parameters */
    const handleGenerateShippingLabel = (upsBox:any) => {
      ref.current?.scrollIntoView({behavior: 'smooth'});
      setsubmitButtonEnabled(2);
      setShippingLabelRequest(upsBox);
      setShippingTypeVal('PREPAID_SHIPPING');
    }
  
  const handleConfirmationCancel=()=>{
    setCheckShippingOption(true);
    setShippingSelectedOption('')
    setTabTitle('CONFIRMATION');
    setTabBackButtonText('');
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
    setConfirmBox(false);
    setShippingTypeVal('');
  }

  const handleBoxeChange=(e:any)=>{
    if(e===false){
      setsubmitButtonEnabled(1);
    }
  }

  // UPS confirmation 
  const handleUpsConfirmation=()=>{
    setsubmitButtonEnabled(2);
    setSelfShippingWarehouseCode('0');
    setWarehouseCode('0');
    setShippingTypeVal('PREPAID_SHIPPING');
  }
  // Select DropOff warehouse and reset - Shipping Warehouse, Shipping Label
  const handleDropOffWarehouse=(dropOffWarehouse:string)=>{
    if(dropOffWarehouse==='0'){
      setsubmitButtonEnabled(1);
    }else{
     setWarehouseCode(dropOffWarehouse);
     setSelfShippingWarehouseCode('0');
     setsubmitButtonEnabled(2);
     setShippingTypeVal('DROP_OFF_STORE');
    }
   }

   // Select Self Shipping warehouse
   const handleSelfShippingWarehouse=(selfSAhippingWarehouseCode:any)=>{
    if(selfSAhippingWarehouseCode==='0'){
      setsubmitButtonEnabled(1);
    }else{
    setSelfShippingWarehouseCode(selfSAhippingWarehouseCode);
    setWarehouseCode('0');
    setsubmitButtonEnabled(2);
    setShippingTypeVal('SELF_SHIPPING');
    }
   }

  return (
    <div className="rp-returns-cart-slide">
      <SlideMenu
        mounted={showSlide}
        goBackTitle={t('common.backToResults')}
        level={10000}
        handleCloseMenu={closeSlide}
      >
        <div className="rp-returns-cart-slide-container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <h3 className="rp-returns-cart-slide-title">
                  {t('myReturns.returnsCart')}
                </h3>
              </div>
            </div>
          </div>

          <ReturnsOptions
            rmaList={rmaList}
            selectedOption={selectedOption}
            handleChangeOption={handleChangeOption}
            handlePoNumber={handlePoNumber}
            rmaSelected={rmaSelected}
            poNumber={poNumber}
            handleSelectedRma={handleSelectedRma}
          />

          <ReturnsTable
            partsToReturn={partsToReturn}
            removeItemFromReturn={removePartFromReturnList}
            editPartFromReturnList={editPartFromReturnList}
          />

{shippingTabToShow && 
            <div className="return-shipping-row">
              <div className="col">
                <div className="rp-return-details-desktop--tabs-container-cart-slide">
                  <div className="rp-tabs">
                    <div className="rp-return-tabs--tab-cart-slide">
                      <div>{tabTitle}</div>
                      <div className="tab-back-btn-text" onClick={handleBackButtion}>{tabBackButtonText}</div>
                    </div>
                      <div className="rp-tabs--content">
                        <div className="rp-pick-up-tab--info">
                          <div className="return-shipping-container">
                            {checkShippingOtiopn &&  
                              <ShippingOptions
                                shippingSelectedOption={shippingSelectedOption}
                                handleShippingChangeOption={handleShippingChangeOption}
                                rmaSelected={rmaSelected}
                              />
                            }

                            {shippingSelectedOption==="shipToDistribution" && 
                              <DistributionOptions
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                              />
                            }

                            {shippingSelectedOption==="dropOffAtStore" && 
                              <DropOffStore
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleDropOffWarehouse={handleDropOffWarehouse}
                              />
                            }



                              {distributionSelectedOption==="purchasePrepaidShipping" && confirmBox===false && 
                              <BoxInfo
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                userData={userData}
                                totalItemPrice={totalItemPrice}
                                upsErrorMessage={upsErrorMessage}
                                isLoader={isLoader}
                                shippingType={shppingTypeVal}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleBoxeChange={handleBoxeChange}
                              />
                            }
                             {confirmBox && 
                              <BoxConfirm
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                boxResponseData={upsResponseData}
                                totalShippingCharge={upsTotalShippingCharge}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleUpsConfirmation={handleUpsConfirmation}
                                shippingType={shppingTypeVal}
                                totalItemPrice={totalItemPrice}
                              />
                            }

                             {distributionSelectedOption==="selfShipping" && 
                              <SelfShipping
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleSelfShippingWarehouse={handleSelfShippingWarehouse}
                              />
                            }
                            {preSaveForLaterAlt &&
                                        <SaveForLaterConfirm
                                        handleSaveForLater={handleSaveForLater}
                                        />
                                        }
                          
                          </div>
                          
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            }

          <div className="rp-returns-cart-slide-actions">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <Button
                    action={shppingTypeVal===""?handleSaveForLater:handlePreSaveForLater}
                    buttonClass="rp-returns-cart-slide-button outlined"
                    label={t('common.saveForLater')}
                    textTransform="uppercase"
                    disabled={isDisabledLater()}
                  />
                </div>
              </div>
              <div className="row" ref={ref}>
                <div className="col-12">
                  <Button
                    action={handleSubmitNow}
                    buttonClass="rp-returns-cart-slide-button filled"
                    label={t('common.submitNow')}
                    textTransform="uppercase"
                    disabled={isDisabled()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </SlideMenu>
    </div>
  );
};

export default ReturnsCartSlide;
